import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { label } from 'src/app/constants/labels';

@Component({
  selector: 'app-sp-userdialog',
  templateUrl: './userdialog.component.html',
  styleUrls: ['./userdialog.component.scss']
})
export class SpUserdialogComponent implements OnInit {

  labels;
  isValid: boolean = true;
  errorTxtEnterValue: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, public dialogRef: MatDialogRef<SpUserdialogComponent>) { }
  /**
   * intilize the user dailog 
   */
  ngOnInit() {
    this.labels = label;
  }
  /**
   * confirmation message
   */
  confirmBtn(data): void {
    if(data.textVal !== '' && data.textVal !== undefined){
      this.isValid = true;
      this.dialogRef.close(data);
    } else {
      this.isValid = false;
    }
  }
}
/**
   * Dailog data Model
   */
export interface DialogData {
  textVal: string;
  appTxtid: number;
}
